import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QuickActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  color?: 'blue' | 'violet' | 'teal';
  className?: string;
}

// CU 2.0: one orange primary (navy label: white on orange fails AA), the others navy and outlined.
// The `color` prop names are kept so existing callers do not change.
const COLOR_MAP: Record<'blue' | 'violet' | 'teal', string> = {
  blue: 'bg-brand text-on-brand shadow-brand hover:bg-brand-hover border border-transparent',
  violet: 'bg-navy text-white hover:bg-navy-light border border-transparent',
  teal: 'bg-surface text-navy border-[1.5px] border-line-strong hover:border-brand hover:text-brand-dark',
};

export function QuickActionButton({
  icon: Icon,
  label,
  onClick,
  color = 'blue',
  className,
}: QuickActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'rounded-md px-4 py-3 font-heading font-bold text-sm flex items-center gap-2 transition-colors shadow-sm',
        COLOR_MAP[color],
        className,
      )}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );
}
